import { Link } from "react-router-dom";
import { Button } from "@telluscompany/design-system";
import { useLocalization } from "@i18n";

interface ErrorActionsProps {
  canRetry: boolean;
  canGoBack: boolean;
  onRetry: () => void;
  onGoBack: () => void;
}

export const ErrorActions = ({
  canRetry,
  canGoBack,
  onRetry,
  onGoBack,
}: ErrorActionsProps) => {
  const { translate } = useLocalization();

  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      {canRetry && (
        <Button onClick={onRetry} variant="primary">
          {translate("errors.appBoundary.retry")}
        </Button>
      )}

      {canGoBack && (
        <Button onClick={onGoBack} variant="secondary">
          {translate("common.goBack")}
        </Button>
      )}

      <Link to="/">
        <Button variant="secondary">
          {translate("errors.appBoundary.goHome")}
        </Button>
      </Link>
    </div>
  );
};
